import { useContext } from 'react';
import GlobalContext from '../../common/context/global';

export default function useAnalytics() {
  return useContext(GlobalContext).analytics;
}
